import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import _ from 'lodash';
import 'client/styles/selectionList.scss';
import InteractiveListItem, { InteractiveListItemShape } from './interactiveListItem';

const propTypes = {
  allItems: PropTypes.arrayOf(InteractiveListItemShape).isRequired,
  className: PropTypes.string,
  itemClickHandler: PropTypes.func,
};

const defaultProps = {
  className: null,
  itemClickHandler: () => {},
};

const InteractiveList = ({ allItems, className, itemClickHandler }) => {
  const toggleInteractiveItems = _.map(allItems, item =>
    <div key={item.id}>
      <InteractiveListItem
        item={item}
        clickHandler={itemClickHandler} />
    </div>,
  );

  return (
    <div className={cx('selection-items', className)}>
      {toggleInteractiveItems}
    </div>
  );
};

InteractiveList.propTypes = propTypes;
InteractiveList.defaultProps = defaultProps;

export default InteractiveList;
